export enum TrafficTicketTrackingStatusEnum {
  NotNotified = 1,
  Notified = 2,
  NotifyFail = 3,
  DriverAppointed = 4,
  Contested = 5,
  SendLink = 6,
  MarkAsPaid = 7,
  ChooseNotIndicate = 8
}